import { createApp } from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";
import { createGtm } from '@gtm-support/vue-gtm';

createApp(App).use(VueGtag, {
    config: { id: "G-3XLE0FWXPC" }
  }).use(createGtm, { id: 'GTM-WSC6XMJX'}).mount("#app");
